export default "__VITE_ASSET__CgyaC_lv__"